import { commonEnvironment } from './environment.common'

export const environment = {
  ...commonEnvironment,
  production: false,
  baseUrl: 'https://gateway.web-dev.eloaded.eu',
  appPublicUrl: 'https://charge-dev.eloaded.eu'
}
